import { mutatorAction } from "satcheljs";

import { TeamPermissionsStore } from "../store/TeamPermissionsStore";

export const resetTeamPermissions = mutatorAction("resetTeamPermissions", () => {
    TeamPermissionsStore().permission = null;
});